
<template>
  <div>
    <p>
      <strong>{{loc('sender')}}</strong>: {{user.firstName}} {{user.lastName}}<br>
      <strong>{{loc('organization')}}</strong>: {{company.name}}<br>
      <strong>{{loc('address')}}</strong>: {{company.address}}, {{company.postalCode}} {{company.postOffice}}, {{company.country && company.country.name}}<br>
      <strong>{{loc('phone')}}</strong>: {{user.phone}}<br>
      <strong>{{loc('email')}}</strong>: {{user.username}}
    </p>
  </div>
</template>

<script>
export default {
  name: 'VComplaintUserInfo',
  props: ['user-id', 'user-data', 'company-data'],
  data: function () {
    return {
      companyId: null
    }
  },
  computed: {
    user() {
      // If userData is passed, use that
      if(this.$props.userData) {
        return this.$props.userData;
      }

      const user = this.$store.state.users.filter(user => user.id === this.$props.userId)[0];

      if(user) {
        this.companyId = user.company;
        this.$store.dispatch('getCompany', this.companyId);
      }

      return user || {};
    },
    company() {
      // If companyData is passed, use that
      if(this.$props.companyData) {
        return this.$props.companyData;
      }
      const company = this.$store.state.companies.filter(company => company.id === this.companyId)[0];

      return company || {};
    }
  },
  mounted() {

    // If userData is passed, use that
    if(this.$props.userData) {
      return this.$props.userData;
    }

    if(this.$props.userId) {
      this.$store.dispatch('getUser', this.$props.userId);
    }
  },
  watch: {
    userId(val) {
      if(val) {
        this.$store.dispatch('getUser', val);
      }
    }
  }
}
</script>
